export const LANGUAGES = {
	EN: 'en',
	RU: 'ru',
};